export const FETCH_EIFLIST_REQUEST = 'FETCH_EIFLIST_REQUEST'
export const FETCH_EIFLIST_SUCCESS = 'FETCH_EIFLIST_SUCCESS'
export const FETCH_EIFLIST_FAILURE = 'FETCH_EIFLIST_FAILURE'
export const FETCH_EIFLIST_UPDATE = 'FETCH_EIFLIST_UPDATE'

